import { TranslationObject } from '@ngx-translate/core';

export class FactMetadata {
  factNameId: string;
  title: TranslationObject;
  description: TranslationObject;
  unit: string;
  isFactOfInterest?: boolean;
  availableGeoTypes?: string[];

  constructor(
    nameId: string,
    title: TranslationObject,
    description: TranslationObject,
    unit: string,
    isFactOfInterest?: boolean,
    availableGeoTypes?: string[]
  ) {
    this.factNameId = nameId;
    this.title = title;
    this.description = description;
    this.unit = unit;
    this.isFactOfInterest = isFactOfInterest;
    this.availableGeoTypes = availableGeoTypes;
  }
}